export const CUSTOM_BASE_PLAN_VALUE = '__custom_base_plan__';
export const UNASSIGNED_BASE_PLAN_FILTER_VALUE = '__unassigned_base_plan__';

const getNamedBasePlanFilterValue = (planId) => `plan:${planId}`;

export const getBasePlanSelectionValue = (selection = {}) => {
  const { basePlanId = '', basePlanIsCustom = false } = selection || {};
  if (basePlanIsCustom) return CUSTOM_BASE_PLAN_VALUE;
  return basePlanId || '';
};

export const getBasePlanDraftUpdate = (value) => ({
  basePlanId: value === CUSTOM_BASE_PLAN_VALUE ? '' : value,
  basePlanIsCustom: value === CUSTOM_BASE_PLAN_VALUE,
});

export const getBasePlanOptions = (basePlans = []) => [
  { value: CUSTOM_BASE_PLAN_VALUE, label: 'Custom' },
  ...basePlans.map((plan) => ({ value: plan.id, label: plan.name })),
  { value: '', label: 'Not assigned' },
];

export const getBasePlanDisplayLabel = (selection = {}) => {
  const { basePlanName = '', basePlanIsCustom = false } = selection || {};
  if (basePlanIsCustom) return 'Custom';
  return basePlanName || '';
};

export const getBasePlanFilterValue = (selection = {}) => {
  const { basePlanId = '', basePlanIsCustom = false } = selection || {};
  if (basePlanIsCustom) return CUSTOM_BASE_PLAN_VALUE;
  if (basePlanId) return getNamedBasePlanFilterValue(basePlanId);
  return UNASSIGNED_BASE_PLAN_FILTER_VALUE;
};

export const getBasePlanFilterOptions = (homes = []) => {
  const namedPlans = new Map();

  homes.forEach((home) => {
    if (home.basePlanId && home.basePlanName) {
      const existingPlan = namedPlans.get(home.basePlanId);
      namedPlans.set(home.basePlanId, {
        name: home.basePlanName,
        size: existingPlan?.size ?? home.basePlanSize,
      });
    }
  });

  const getNumericSize = (size) => {
    const numericSize = Number(size);
    return Number.isFinite(numericSize) && numericSize > 0 ? numericSize : null;
  };

  return [
    { value: CUSTOM_BASE_PLAN_VALUE, label: 'Custom' },
    ...[...namedPlans.entries()]
      .map(([id, { name, size }]) => ({
        value: getNamedBasePlanFilterValue(id),
        label: name,
        size: getNumericSize(size),
      }))
      .sort((a, b) => {
        if (a.size !== null && b.size !== null && a.size !== b.size) return a.size - b.size;
        if (a.size !== null) return -1;
        if (b.size !== null) return 1;
        return a.label.localeCompare(b.label);
      })
      .map(({ value, label }) => ({ value, label })),
    { value: UNASSIGNED_BASE_PLAN_FILTER_VALUE, label: 'Unassigned' },
  ];
};

export const saveBasePlanSelection = (object, draft, createPlanPointer) => {
  if (draft.basePlanId) {
    object.set('basePlan', createPlanPointer(draft.basePlanId));
    object.unset('basePlanIsCustom');
    return;
  }

  object.unset('basePlan');
  if (draft.basePlanIsCustom) object.set('basePlanIsCustom', true);
  else object.unset('basePlanIsCustom');
};
